var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M5.219.114a.52.52 0 0 0-.648 0C4.396.252.289 3.567.289 7.073.29 9.974 2.183 12 4.894 12c2.79 0 4.814-2.072 4.814-4.926C9.708 3.74 5.402.26 5.219.114m.303 10.581a.52.52 0 0 1-.258-1.007c.095-.025 2.174-.598 2.174-2.683a.52.52 0 1 1 1.04 0c0 2.324-1.934 3.43-2.956 3.69"
})));
export default SvgDrop;